<template>
    <span :class="cls" :style="style">{{ label }}</span>
</template>
<script>
import { mapGetters } from "vuex";

export default {
    name: "FGDictRendererCN",
    props: {
        dictNo: {
            type: String,
            required: true
        },
        value: {
            type: String,
            required: false
        }
    },
    data() {
        return {
            cls: null,
            style: null,
            label: null
        };
    },
    methods: {
        ...mapGetters(["getDictData"]),
        dictValue() {
            this.label = null;
            this.cls = null;
            this.style = null;
            let dictData = this.getDictData()[this.dictNo];
            if (dictData) {
                let data = dictData.find((item, index, arr) => item.text === this.value);
                if (data) {
                    this.label = data.text;
                    this.cls = data.cls;
                    this.style = data.style;
                }
            }
        }
    },
    watch: {
        dictNo() {
            this.dictValue();
        },
        value() {
            this.dictValue();
        }
    },
    created() {
        this.dictValue();
    }
};
</script>
